import {
  AccountModal,
  TransactionModal,
  WalletOptionsModal,
} from '@/components/organisms'
import { MODALS } from '@/constants'
import { createContext, useCallback, useState } from 'react'

export const ModalsContext = createContext({})

const ModalsProvider = ({ children }) => {
  const [modals, setModals] = useState({})

  const openModal = useCallback((modal, props = {}) => {
    setModals((prevModals) => ({
      ...prevModals,
      [modal]: { active: true, props },
    }))
  }, [])

  const closeModal = useCallback((modal = null) => {
    if (modal) {
      setModals((prevModals) => ({
        ...prevModals,
        [modal]: { ...prevModals[modal], active: false },
      }))
    } else {
      setModals({})
    }
  }, [])

  const modalsArray = [
    { Component: TransactionModal, modalName: MODALS.TRANSACTION },
    { Component: AccountModal, modalName: MODALS.ACCOUNT },
    { Component: WalletOptionsModal, modalName: MODALS.WALLET_OPTIONS },
  ]

  return (
    <ModalsContext.Provider value={{ openModal, closeModal }}>
      {children}

      {modalsArray.map(({ Component, modalName }) => (
        <Component
          key={modalName}
          isOpen={modals[modalName]?.active}
          onClose={() => closeModal(modalName)}
          {...modals[modalName]?.props}
        />
      ))}
    </ModalsContext.Provider>
  )
}

export default ModalsProvider
